import { render, staticRenderFns } from "./RouteToCluster.vue?vue&type=template&id=7fec886c&"
import script from "./RouteToCluster.vue?vue&type=script&setup=true&lang=js&"
export * from "./RouteToCluster.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports